import {
	Select,
	SelectArrow,
	SelectItem,
	SelectLabel,
	SelectPopover,
	SelectProvider,
	SelectValue,
} from "@ariakit/react";
import { classed } from "@frend-digital/ui";
import styles from "./Select.module.css";

export const Root = classed(SelectProvider);

export const Value = SelectValue;
export const Arrow = SelectArrow;
export const Label = classed(SelectLabel, styles.label);
export const Trigger = classed(Select, styles.button);
export const Popover = classed(SelectPopover, styles.popover);
export const Item = classed(SelectItem, styles.selectItem);

export {
	Arrow as SelectArrow,
	Item as SelectItem,
	Label as SelectLabel,
	Popover as SelectPopover,
	Root as SelectRoot,
	Trigger as SelectTrigger,
	Value as SelectValue,
};
